// import { toast } from 'react-toastify';
import { Types } from '../reducers/systems';
import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import errorMessages from 'utils/consts/errors';

// Asynchronous

// Synchronous
export const createSystem = (systemData, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.post(serverRoutes.Systems.item(), systemData)
      .then((response) => {
        dispatch({
          type: Types.CREATE_SYSTEMS,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
        console.log(err, err?.response?.data)
      })
  }
}

export const getSystems = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Systems.item(''), { params: { page, limit, query, sort } })
      .then((response) => {
        dispatch({
          type: Types.GET_PAGED_SYSTEMS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_PAGED_SYSTEMS,
          payload: []
        });
      })
  }
}

export const getAllConsumptionSystems = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Systems.getAllConsumption)
      .then((response) => {
        dispatch({
          type: Types.GET_CONSUMPTION_SYSTEMS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_CONSUMPTION_SYSTEMS,
          payload: []
        });
      })
  }
}

export const getAllSourceSystems = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Systems.getAllSource)
      .then((response) => {
        dispatch({
          type: Types.GET_SOURCE_SYSTEMS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_SOURCE_SYSTEMS,
          payload: []
        });
      })
  }
}

export const getUserCatalogSystemsAvailable = (userId, collectionId) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Systems.getUserCatalogSystemsAvailable(`/${userId}`,`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_USER_SYSTEMS_AVAILABLE,
          payload: response.data
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_USER_SYSTEMS_AVAILABLE,
          payload: null,
        })
      })
  }
}

export const getSystem = (systemslug) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Systems.profile(`/${systemslug}`))
      .then((response) => {
        dispatch({
          type: Types.GET_SYSTEM,
          payload: response.data
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_SYSTEM,
          payload: null,
        })
      })
  }
}

export const updateSystem = (systemId, systemData, callback) => {
  return (dispatch) => {
    axiosInstanceV2.put(serverRoutes.Systems.profile(`/${systemId}`), systemData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_SYSTEM,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
        console.log(err, err?.response?.data)
      });
  }
}

export const deleteSystem = (systemId, callback) => {
  return (dispatch) => {
    axiosInstanceV2.delete(serverRoutes.Systems.item(`/${systemId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_SYSTEM,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err)
        callback(false);
      })
  }
}
